export default "__VITE_ASSET__B0q1oSoU__"